// React
import React from 'react';

// Packages
import t from 'prop-types';
import { useLabels, useFormat } from 'utilities/hooks';

// Utilities

// Components
import Card from 'components/_cardContentElements';

const ResultsProductsAndInventionsComponent = ({
    item,
    theme = 'teal',
    wrap = false,
}) => {
    // ///////////////////
    // DATA
    // ///////////////////

    const { Description__c } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <Card.CardContentWrapper
            {...{
                wrap,
            }}>
            {/* Description */}
            {Description__c && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                    }}>
                    <p>{Description__c}</p>
                </Card.CardContentSection>
            )}

            {/* Details */}
            <ResultsProductsAndInventionsDetails {...{ item, theme }} />
        </Card.CardContentWrapper>
    );
};

const ResultsProductsAndInventionsDetails = ({ item, theme }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();
    const format = useFormat();

    // ///////////////////
    // DATA
    // ///////////////////

    const {
        Clinical_Trial_Id__c,
        Clinical_Phase__c,
        Result_Start_Date__c,
        Result_End_Date__c,
        Field_Trial_Type__c,
    } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            {/* Various Info */}
            {[Clinical_Trial_Id__c, Clinical_Phase__c].some(x => x) && (
                <Card.CardContentPairBox>
                    {Field_Trial_Type__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Field_Trial_Type__c'
                                ),
                                value: Field_Trial_Type__c,
                            }}
                        />
                    )}

                    {Clinical_Trial_Id__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Clinical_Trial_Id__c'
                                ),
                                value: Clinical_Trial_Id__c,
                            }}
                        />
                    )}

                    {Clinical_Phase__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Clinical_Phase__c'
                                ),
                                value: Clinical_Phase__c,
                            }}
                        />
                    )}
                </Card.CardContentPairBox>
            )}

            {/* Start date / End date  */}
            <Card.CardContentDates
                {...{
                    theme,
                    startDate: Result_Start_Date__c,
                    startDateTitle: object.label(
                        'Initiative_Result__c.Result_Start_Date__c'
                    ),
                    endDate: item?.Result_End_Date__c,
                    endDateTitle: object.label(
                        'Initiative_Result__c.Result_End_Date__c'
                    ),
                }}
            />
        </>
    );
};

ResultsProductsAndInventionsComponent.propTypes = {
    item: t.object,
};

ResultsProductsAndInventionsComponent.defaultProps = {};

export { ResultsProductsAndInventionsDetails };
export default ResultsProductsAndInventionsComponent;
